import React from "react";
import { useTranslation } from "react-i18next";

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";

import { Icons } from "../../../../assets/icons";
import { Images } from "../../../../assets/images";
import {
  ALL_EVENT,
  EMPTY_STRING,
  eventBookingStatus,
  recapDetailsKeys,
  SHUTTERB_DETAILS_KEYS,
} from "../../../../constants";
import {
  generateRecapDetails,
  generateShutterbDetails,
  normalizeValue,
} from "../../../../shared";
import CustomTooltip from "../../../../shared/components/ToolTip/CustomTooltip";
import IconButton from "../../../../shared/components/IconButton/IconButton";
import ProfileImage from "../../../../shared/components/ProfileImage/ProfileImage";
import useResponsiveView from "../../../../shared/hooks/useResponsiveView";

const { ChevronDownIcon, DeleteIcon } = Icons;
const { RecapImage } = Images;

const CartSummaryMobileView = (props) => {
  const {
    updatedFormState,
    allEventsRecaps,
    handleDeleteShutterB,
    handleDeleteRecap,
    isSBTipExtendCart,
    isEditEvent,
    isAddUpdateRecap,
  } = props;

  const { t } = useTranslation("common");

  const { isMobileView } = useResponsiveView();

  return (
    <div className="cart-summary-mobile-view">
      {updatedFormState?.map((event, eventIndex) => (
        <Accordion
          key={event.id}
          defaultExpanded
          className="cart-summary-accordion-mobile-view"
        >
          <AccordionSummary
            className="cart-accordion-summary"
            expandIcon={<ChevronDownIcon />}
            aria-controls={`panel-${event.id}-content`}
            id={`panel-${event.id}-header`}
          >
            <div className="event-header label-content-500">
              {normalizeValue(event.eventName)}
            </div>
          </AccordionSummary>

          <AccordionDetails>
            {/* Selected ShutterBs */}
            {!isAddUpdateRecap &&
              event?.orderItems?.map((shutterB, shutterBIndex) => (
                <div
                  key={`${shutterB.sbUserId}-${event.id}-${shutterBIndex}`}
                  className={`cart-summary-box d-flex align-items-center p-3 g-4 position-relative ${
                    shutterB?.status === eventBookingStatus.CANCEL
                      ? "cart-summary-table-deleted"
                      : EMPTY_STRING
                  }`}
                >
                  <span className="shutterb-profile-image">
                    <ProfileImage
                      imageUrl={
                        shutterB?.sbportfolioGalleries?.[0]?.profileImageUrl ||
                        shutterB?.sbUser?.sbPortfolios?.[0]?.profileImageUrl ||
                        EMPTY_STRING
                      }
                    />
                  </span>
                  <div>
                    {generateShutterbDetails(
                      shutterB,
                      event,
                      null,
                      isEditEvent,
                      isMobileView
                    ).map((item, _idx) => (
                      <div className="d-flex align-items-center g-1" key={_idx}>
                        <p className="shutterb-title label-content-600 mb-0 shutterb-deleted">
                          {item.label}
                        </p>
                        <p
                          className={`text-content mb-0 shutterb-deleted ${
                            item.key === SHUTTERB_DETAILS_KEYS.STATUS
                              ? item.className
                              : EMPTY_STRING
                          }`}
                        >
                          {item.value}
                        </p>
                      </div>
                    ))}
                  </div>

                  <CustomTooltip
                    id="tooltip"
                    title={
                      event.orderItems?.filter(
                        (f) => f.status !== eventBookingStatus.CANCEL
                      )?.length === 1
                        ? t("atleast_1_shutterb_required_message")
                        : ""
                    }
                    arrow
                    placement="right"
                  >
                    <span tabIndex="0">
                      <IconButton
                        className="position-absolute cart-delete-icon"
                        disabled={
                          shutterB.status === eventBookingStatus.CANCEL ||
                          event.status === eventBookingStatus.NOTIFY_ADMIN ||
                          (event.orderItems?.filter(
                            (f) => f.status !== eventBookingStatus.CANCEL
                          )?.length === 1 &&
                            !isSBTipExtendCart)
                        }
                        icon={<DeleteIcon />}
                        handleClick={() =>
                          handleDeleteShutterB(
                            event.id,
                            shutterB.sbUserId,
                            eventIndex,
                            shutterBIndex
                          )
                        }
                      />
                    </span>
                  </CustomTooltip>
                </div>
              ))}

            {/* Event-specific reels */}
            {event?.reels?.map((reelItem, recapIndex) => (
              <div
                key={`reelItem-${reelItem.id}-${recapIndex}`}
                className={`d-flex align-items-center p-3 g-4 cart-summary-box position-relative ${
                  reelItem?.status === eventBookingStatus.CANCEL
                    ? "cart-summary-table-deleted"
                    : EMPTY_STRING
                }`}
              >
                <span className="shutterb-profile-image">
                  <img
                    src={RecapImage}
                    alt="reelItem"
                    className="circle-wrapper"
                  />
                </span>

                <div>
                  {generateRecapDetails(
                    reelItem,
                    props.recapTypes,
                    EMPTY_STRING,
                    isEditEvent
                  ).map((item, _idx) => (
                    <div className="d-flex align-items-center" key={_idx}>
                      <p className="shutterb-title label-content-600 mb-0 recap-deleted">
                        {item.label}
                      </p>
                      <p
                        className={`text-content mb-0 recap-deleted ${
                          item.key === recapDetailsKeys.STATUS
                            ? item.className
                            : EMPTY_STRING
                        }`}
                      >
                        {item.value}
                      </p>
                    </div>
                  ))}
                </div>
                <CustomTooltip
                  id="tooltip"
                  title={t("cat_summary_table_recap_remove_message")}
                  arrow
                  placement="right"
                >
                  <span tabIndex="0">
                    <IconButton
                      className="position-absolute cart-delete-icon"
                      icon={<DeleteIcon />}
                      disabled={true} //{reelItem?.status === eventBookingStatus.CANCEL}
                      handleClick={() =>
                        handleDeleteRecap(event.id, reelItem.reelMode)
                      }
                    />
                  </span>
                </CustomTooltip>
              </div>
            ))}
          </AccordionDetails>
        </Accordion>
      ))}

      {/* All Events reelItem */}
      {allEventsRecaps?.map((reelItem, index) => (
        <div
          key={`reelItem-${reelItem.id}-${index}`}
          className={`cart-summary-accordion-mobile-view d-flex align-items-center p-3 g-4 cart-summary-box position-relative ${
            reelItem?.status === eventBookingStatus.CANCEL
              ? "cart-summary-table-deleted"
              : EMPTY_STRING
          }`}
        >
          <span className="shutterb-profile-image">
            <img src={RecapImage} alt="reelItem" className="circle-wrapper" />
          </span>

          <div>
            {generateRecapDetails(
              reelItem,
              props.recapTypes,
              ALL_EVENT.name,
              isEditEvent
            ).map((item, _idx) => (
              <div className="d-flex align-items-center" key={_idx}>
                <p className="shutterb-title label-content-600 mb-0 recap-deleted">
                  {item.label}
                </p>
                <p
                  className={`text-content mb-0 recap-deleted ${
                    item.key === recapDetailsKeys.STATUS
                      ? item.className
                      : EMPTY_STRING
                  }`}
                >
                  {item.value}
                </p>
              </div>
            ))}
          </div>

          <CustomTooltip
            id="tooltip"
            title={t("cat_summary_table_recap_remove_message")}
            arrow
            placement="right"
          >
            <span tabIndex="0">
              <IconButton
                className="position-absolute cart-delete-icon"
                icon={<DeleteIcon />}
                disabled={true} //{reelItem?.status === eventBookingStatus.CANCEL}
                handleClick={() =>
                  handleDeleteRecap(ALL_EVENT.id, reelItem.reelMode)
                }
              />
            </span>
          </CustomTooltip>
        </div>
      ))}
    </div>
  );
};

export default CartSummaryMobileView;
